import React from 'react';
import './ProjectsSection.css';

const ProjectsSection = ({ config }) => {
  return (
    <div className="projects-section">
      <div className="projects-content">
        <div className="projects-header">
          <h2 className="projects-title">{config.title}</h2>
          <h3 className="project-name">{config.projectName}</h3>
          <p className="project-description">
            {config.description}
          </p>
        </div>
        
        <div className="project-side-image">
          <img 
            src={config.sideImage} 
            alt="Project Side View" 
            className="side-img"
          />
        </div>
      </div>
    </div>
  );
};

export default ProjectsSection;
